import { render, staticRenderFns } from "./AssignFormData.vue?vue&type=template&id=460e05d6"
import script from "./AssignFormData.vue?vue&type=script&lang=js"
export * from "./AssignFormData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports